

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class EventPhase_ManagedObject

class EventPhase_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: name
    set name(value:string) {
        this.setValueForKey(value, 'name');
    }
    get name():string {
        return this.valueForKey('name');
    }
    set namePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'name');
    }
    get namePrimitiveValue():string {
        return this.primitiveValueForKey('name');
    }

    // Property: orderIndex
    set orderIndex(value:number) {
        this.setValueForKey(value, 'orderIndex');
    }
    get orderIndex():number {
        return this.valueForKey('orderIndex');
    }
    set orderIndexPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'orderIndex');
    }
    get orderIndexPrimitiveValue():number {
        return this.primitiveValueForKey('orderIndex');
    }
    // Relationship: event
    set event(value:VenueEvent) {
        this.setValueForKey(value, 'event');
    }
    get event():VenueEvent {
        return this.valueForKey('event') as VenueEvent;
    }

    // Relationship: items
    protected _items:MIOManagedObjectSet = null;
    get items():MIOManagedObjectSet {
        return this.valueForKey('items');
    }
    addItemsObject(value:EventPhaseItem) {
        this._addObjectForKey(value, 'items');
    }
    removeItemsObject(value:EventPhaseItem) {
        this._removeObjectForKey(value, 'items');
    }
    // Relationship: preset
    set preset(value:Preset) {
        this.setValueForKey(value, 'preset');
    }
    get preset():Preset {
        return this.valueForKey('preset') as Preset;
    }
    // Relationship: rate
    set rate(value:Rate) {
        this.setValueForKey(value, 'rate');
    }
    get rate():Rate {
        return this.valueForKey('rate') as Rate;
    }
}
